export class SetToken {
  static readonly type = '[PaymentInfo] Set Token';
  constructor(public payload: string) {}
}
export class ClearToken {
  static readonly type = '[PaymentInfo] Clear Token';
}
export class SetTokenValidation {
  static readonly type = '[PaymentInfo] Set Token Validation Message';
  constructor(public payload: string) {}
}
export class SetNumber {
  static readonly type = '[PaymentInfo] Set CC Number';
  constructor(public payload: string) {}
}

export class SetMonth {
  static readonly type = '[PaymentInfo] Set CC Month';
  constructor(public payload: number | string) {}
}

export class SetYear {
  static readonly type = '[PaymentInfo] Set CC Year';
  constructor(public payload: number | string) {}
}

export class SetCVV {
  static readonly type = '[PaymentInfo] Set CC CVV';
  constructor(public payload: number | string) {}
}

export class SetAccount {
  static readonly type = '[PaymentInfo] Set Check Account';
  constructor(public payload: string) {}
}

export class SetRouting {
  static readonly type = '[PaymentInfo] Set Check Routing';
  constructor(public payload: string) {}
}

export class SetMethod {
  static readonly type = '[PaymentInfo] Set Payment Method';
  constructor(public payload: string) {}
}

export class SetCardRetain {
  static readonly type = '[PaymentInfo] Set Card Retain';
  constructor(public payload: boolean) {}
}

export class SetMethodAdd {
  static readonly type = '[PaymentInfo] Set Method Add';
  constructor(public payload: boolean) {}
}

export class SetCardType {
  static readonly type = '[PaymentInfo] Set Card Type';
  constructor(public payload: string) {}
}
